import useAPI from '@/hooks/useAPI';
import DemographicsRepository, {
  DemographicOptionKey
} from '@/repositories/DemographicsRepository';

export const useDemographicOptions = (optionKey: DemographicOptionKey) => {
  const demographicsRepository = DemographicsRepository();

  const { data, isLoading, error } = useAPI({
    queryKey: ['demographics', 'options', optionKey],
    queryFn: () => demographicsRepository.getSpecificDemographicOptions(optionKey)
  });

  return {
    options: data || [],
    isLoading,
    error
  };
};

export const usePronouns = () => {
  return useDemographicOptions('pronouns');
};
